import { IProjectDataRank } from "../../types/projectDataRanks.types"

export enum ProjectActionType {
  FETCH_PROJECT_DATA_RANKS = "FETCH_PROJECT_DATA_RANKS",
  FETCH_PROJECT_DATA_RANKS_SUCCESS = "FETCH_PROJECT_DATA_RANKS_SUCCESS",
  FETCH_PROJECT_DATA_RANKS_ERROR = "FETCH_PROJECT_DATA_RANKS_ERROR",
}

interface FetchProjects {
  type: ProjectActionType.FETCH_PROJECT_DATA_RANKS
}

interface FetchProjectsSuccess {
  type: ProjectActionType.FETCH_PROJECT_DATA_RANKS_SUCCESS
  payload: IProjectDataRank[]
}

interface FetchProjectsError {
  type: ProjectActionType.FETCH_PROJECT_DATA_RANKS_ERROR
  payload: string
}

export type ProjectAction = FetchProjects | FetchProjectsSuccess | FetchProjectsError

export interface IProjectState {
  projectDataRanks: IProjectDataRank[]
  loading: boolean
  error: string | null
}
